import React, { useContext, useEffect, useReducer, useState } from "react";
import axios from "axios";
import classes from "./NewsEventsPage.module.scss";
import { isMobileOnly, isTablet } from "react-device-detect";
import Pagination from "../../components/UI/Pagination/Pagination";
import NewsEventCard from "./NewsEventCard/NewsEventCard";
import scrollToComponent from "react-scroll-to-component";
import JIcon from "../../components/UI/Icon/JIcon";
import CountSortingContainer from "../../components/UI/CountSortingContainer/CountSortingContainer";
import ReactGa from "react-ga";
import { Helmet } from "react-helmet";
import { HomeBreadcrumb } from "../../components/UI/HomeButton";
import { FormattedMessage } from "react-intl";
import { FETCH_INIT_DATA, IS_LOADING, LANG_EN } from "../../constants";
import update from "immutability-helper";
import { utilScrollUp } from "../../utils/Utils";
import { Context } from "../../context/Wrapper";

const initialState = {
  isLoading: false,
  all_news_events: [],
  product_categories: [],
  showUnder: false,

  defaultOps: 0,
  postPerPage: isMobileOnly || isTablet ? 12 : 5,
  currentPage: 1,
};

const reducer = (state, action) => {
  switch (action.type) {
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case FETCH_INIT_DATA:
      return {
        ...state,
        all_news_events: action.allNewsEvents,
        isLoading: action.isLoading,
      };
    case "FETCH_FILTER":
      return {
        ...state,
        all_news_events: action.payload,
        isLoading: action.isLoading,
      };
    case "SORTING_DATA":
      return {
        ...state,
        all_news_events: action.payload,
        defaultOps: action.defaultOps,
      };
    case "PAGE_SETTINGS":
      return {
        ...state,
        currentPage: action.currentPage,
      };
    case "DEFAULT_OPS":
      return {
        ...state,
        defaultOps: action.payload,
      };
    default:
      return state;
  }
};

const NewsEventsPageHook = (props) => {
  const context = useContext(Context);

  const [initEffect, setInitEffect] = useState(null);
  const [state, dispatch] = useReducer(reducer, initialState);
  const [options] = useState([
    { displayId: "-Pilih-", displayValue: "-Choose Sorting-", value: 0 },
    { displayId: "Baru", displayValue: "New", value: 1 },
    { displayId: "Lama", displayValue: "Old", value: 2 },
  ]);

  const [categories, setCategories] = useState([
    {
      id: 0,
      labelId: "Berita",
      label: "News",
      value: "News",
      is_checked: false,
    },
    {
      id: 1,
      labelId: "Kegiatan",
      label: "Events",
      value: "Events",
      is_checked: false,
    },
  ]);

  const gotoDetail = (slug, paramDetailTitle) => {
    localStorage.setItem("news_events:selected_detail", paramDetailTitle);
    props.history.push("/news-events-detail/" + slug);
  };

  useEffect(() => {
    //============================================
    // console.log('useEffect 1');
    //============================================

    //add by hendra on 14 oct 2020
    ReactGa.pageview(
      window.location.origin.toString() + props.location.pathname
    );
    const loadDocumentTitle = () => {
      document.title = "News & Events Japfa Food | Indonesia | Food Supplier";
    };
    window.scrollTo(0, 0);

    const ourRequest = axios.CancelToken.source();
    const fetchData = async () => {
      dispatch({ type: IS_LOADING, payload: true });
      const header = {headers: {language: context.locale}};
      // axios.get('news_events', header, {cancelToken: ourRequest.token}).then(response => {
      //     const temp_data = response.data.news_events && response.data.news_events.map(x => {
      //         return {...x, is_checked: false}
      //     });
      //
      //     dispatch({
      //         type: FETCH_INIT_DATA
      //         , allNewsEvents: temp_data
      //         , isLoading: false
      //     });
      // });
      const req = await axios.get("news_events", header, {
        cancelToken: ourRequest.token,
      });
      const temp_data =
        req.data.news_events &&
        req.data.news_events.map((x) => {
          return { ...x, is_checked: false };
        });
      dispatch({
        type: FETCH_INIT_DATA,
        allNewsEvents: temp_data,
        isLoading: false,
      });
    };
    try {
      loadDocumentTitle();
      dispatch({ type: "SORTING_DATA", payload: [], defaultOps: 0 });
      setCategories([
        {
          id: 0,
          labelId: "Berita",
          label: "News",
          value: "News",
          is_checked: false,
        },
        {
          id: 1,
          labelId: "Kegiatan",
          label: "Events",
          value: "Events",
          is_checked: false,
        },
      ]);
      fetchData();
      setInitEffect(null);
    } catch (e) {
      //e
    }

    return () => {
      ourRequest.cancel();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname, props.history, context.locale]);

  useEffect(() => {
    //============================================================
    // console.log('useEffect 2');
    //============================================================
    const ourRequest = axios.CancelToken.source(); // <-- 1st step
    const fetchFilterProducts = async () => {
      dispatch({ type: IS_LOADING, payload: true });
      const header = {headers: {language: context.locale}};

      const data = new FormData();
      categories
        .filter((x) => x.is_checked === true)
        .map((x) => {
          data.append("category[]", x.value);
          return null;
        });

      const check1 = categories[0].is_checked;
      const check2 = categories[1].is_checked;
      if (check1 === false && check2 === false) {
        data.append("News", 1);
        data.append("Events", 1);
      }

      const getFilter = await axios.post("news_event_filter", data, header);
      dispatch({
        type: "FETCH_FILTER",
        payload: getFilter.data.news_events,
        isLoading: false,
      });
    };
    try {
      /*---------------------------------------------------------------------------------------
              @desc: fetchFilterProducts akan dieksekusi ketika dari Header Menu dipilih sub category
            * ---------------------------------------------------------------------------------------*/
      if (initEffect !== null) {
        // console.log('fetchFilterProducts');
        // eslint-disable-next-line react-hooks/exhaustive-deps
        fetchFilterProducts();
      } else {
        return;
      }
    } catch (e) {}

    //hooks cleanup
    return () => {
      ourRequest.cancel(); // <-- 3rd step
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, context.locale]);

  const onFilterHandler = (event) => {
    // const datas = context.locale === LANG_EN ? [...categories] : [...categoriesId]
    const datas = [...categories];
    const categoryIndex = datas.findIndex(
      (x) => x.value === event.target.value
    );
    const newData = update(datas[categoryIndex], {
      is_checked: { $set: event.target.checked },
    });
    const categoriesWithUpdated = [...datas];
    categoriesWithUpdated[categoryIndex] = newData;
    // if (context.locale === LANG_EN) {
    //     setCategories(categoriesWithUpdated)
    // } else {
    //     setCategoriesId(categoriesWithUpdated)
    // }
    setCategories(categoriesWithUpdated);
    setInitEffect(true);
  };

  const onSortHandler = (event) => {
    const value = event.target.value;
    switch (+value) {
      case 1:
        dispatch({
          type: "SORTING_DATA",
          payload: state.all_news_events.sort(
            (a, b) =>
              +(a.created_on < b.created_on) || -(a.created_on > b.created_on)
          ),
          defaultOps: value,
        });
        break;
      case 2:
        dispatch({
          type: "SORTING_DATA",
          payload: state.all_news_events.sort(
            (a, b) =>
              +(a.created_on > b.created_on) || -(a.created_on < b.created_on)
          ),
          defaultOps: value,
        });
        break;
      case 0:
        dispatch({
          type: "SORTING_DATA",
          payload: state.all_news_events.sort(
            (a, b) => +(a.id < b.id) || -(a.id > b.id)
          ),
          defaultOps: value,
        });
        break;
      default:
        return state.all_news_events;
    }
  };

  let pagination;
  //Get Current Post
  const indexOfLastData = state.currentPage * state.postPerPage;
  const indexOfFirstData = indexOfLastData - state.postPerPage;
  const currentData =
    state.all_news_events &&
    state.all_news_events.slice(indexOfFirstData, indexOfLastData);
  const paginate = (pageNumber) => {
    dispatch({ type: "PAGE_SETTINGS", currentPage: pageNumber });
    utilScrollUp();
  };
  const paginateNext = () => {
    dispatch({ type: "PAGE_SETTINGS", currentPage: state.currentPage + 1 });
    utilScrollUp();
  };
  const paginatePrev = () => {
    dispatch({ type: "PAGE_SETTINGS", currentPage: state.currentPage - 1 });
    utilScrollUp();
  };
  const pageStart = (pageNumber) => {
    dispatch({ type: "PAGE_SETTINGS", currentPage: pageNumber });
    utilScrollUp();
  };
  const pageEnd = (pageNumber) => {
    dispatch({ type: "PAGE_SETTINGS", currentPage: pageNumber });
    utilScrollUp();
  };
  pagination = (
    <Pagination
      postPerPage={state.postPerPage}
      totalData={
        state.all_news_events !== undefined ? state.all_news_events.length : []
      }
      currentPage={state.currentPage}
      paginate={paginate}
      paginateNext={paginateNext}
      paginatePrev={paginatePrev}
      pageStart={pageStart}
      pageEnd={pageEnd}
    />
  );

  // listOfData = currentData.map((item, index) => {
  //     return (
  //         <li className={classes.Card_li}
  //             key={`${item.id}${index}`}
  //             onClick={() => gotoDetail(item.slug, item.title)}>
  //             <NewsEventCard
  //                 date={item.created_on}
  //                 data={item}
  //                 title={item.title}
  //                 author={item.created_by}
  //                 type={<span className={"jbfs-title-case"}>{item.category}</span>}/>
  //         </li>
  //     )
  // });

  // const datas = context.locale === LANG_EN ? [...categories] : [...categoriesId]
  const listCategory = categories.map((x, index) => {
    return (
      <li key={index}>
        <input
          id={x.id}
          checked={x.is_checked}
          type="checkbox"
          value={x.value}
          onChange={(e) => onFilterHandler(e)}
        />
        <label htmlFor={x.id}>
          {context.locale === LANG_EN ? x.label : x.labelId}
        </label>
      </li>
    );
  });

  return (
    <>
      <div
        className={["violet", classes.NewsEventsPage_container].join(" ")}
        ref={(section) => {
          scrollToComponent.Violet = section;
        }}
      >
        <Helmet>
          <meta
            name="description"
            content={"JAPFA FOOD : Latest news and events"}
          />
          <meta
            name="keywords"
            content={
              "food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"
            }
          />
          <meta name="author" content="" />
          <meta
            property="og:title"
            content={
              "News and Events Japfa Food | Indonesia | Food Supplier"
            }
          />
          <meta
            property="og:description"
            content={"JAPFA FOOD : Latest news and events"}
          />
          <title>
            {localStorage.getItem("selected_page_title") &&
              `${localStorage.getItem(
                "selected_page_title"
              )}${" Japfa Food | Indonesia | Food Supplier"}`}
          </title>

          <link
            rel="canonical"
            href={window.location.origin.toString() + props.location.pathname}
          />
        </Helmet>

        {/*Bread crumbs region*/}
        <section className={[classes.NewsEventsPage_sectionBread].join(" ")}>
          <div
            className={[
              "jbfs-wrapper",
              classes.NewsEventsPage_wrapperBread,
            ].join(" ")}
          >
            <div className={["jbfs-breadcrumb-row"].join(" ")}>
              <HomeBreadcrumb />
              <span>/</span>
              {/*<div>News & Events</div>*/}
              <div>
                <FormattedMessage
                  id={"newsevents.title"}
                  defaultMessage={"News & Events"}
                />
              </div>
            </div>
          </div>
        </section>
        {/*Bread crumbs region*/}

        <section className={classes.NewsEventsPage_sectionHeader}>
          <div
            className={[
              "jbfs-wrapper",
              classes.NewsEventsPage_wrapperHeader,
            ].join(" ")}
          >
            <div>
              {/*<h1>News & Events</h1>*/}
              <h1>
                <FormattedMessage
                  id={"newsevents.title"}
                  defaultMessage={"News & Events"}
                />
              </h1>
            </div>
          </div>
        </section>

        <section
          className={["", classes.NewsEventsPage_sectionContent].join(" ")}
        >
          <div
            className={[
              "jbfs-wrapper",
              classes.NewsEventsPage_wrapperContent,
            ].join(" ")}
          >
            <div className={classes.Content_wrapperLeft}>
              <section className={classes.Filter_wrapper}>
                <div className={classes.FilterMain_row}>
                  <h4>
                    <FormattedMessage
                      id={"newsevents.archive"}
                      defaultMessage={"Archive"}
                    />
                  </h4>
                  <ul>{listCategory}</ul>
                </div>
                <hr />
              </section>
            </div>
            <div className={classes.Content_wrapperRight}>
              {state.all_news_events && (
                <CountSortingContainer
                  data={state.all_news_events}
                  label={
                    <FormattedMessage
                      id={"global.items.title"}
                      defaultMessage={"items"}
                    />
                  }
                  options={options}
                  onSortHandler={onSortHandler}
                  defaultOps={state.defaultOps}
                />
              )}
              {state.all_news_events && (
                <ul className={classes.Cards_wrapper}>
                  {currentData.map((item, index) => {
                    return (
                      <li
                        className={classes.Card_li}
                        key={`${item.id}${index}`}
                        onClick={() => gotoDetail(item.slug, item.title)}
                      >
                        <NewsEventCard
                          date={item.created_on}
                          data={item}
                          title={item.title}
                          author={item.created_by}
                          type={
                            <span className={"jbfs-title-case"}>
                              {item.category}
                            </span>
                          }
                        />
                      </li>
                    );
                  })}
                </ul>
              )}
              <div className={["jbfs-paging-container"].join(" ")}>
                {pagination}
              </div>
            </div>
          </div>
        </section>

        <div className={["jbfs-goto-top-button"].join(" ")}>
          <JIcon
            icontype={"link_to_top"}
            onClick={() =>
              scrollToComponent(scrollToComponent.Violet, {
                offset: -99,
                align: "top",
                duration: 1500,
              })
            }
          />
        </div>
      </div>
    </>
  );
};

export default NewsEventsPageHook;
